import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Button, theme } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DashboardOutlined,
  TableOutlined,
  ToolOutlined,
  BellOutlined,
  LogoutOutlined,
  NotificationOutlined,
  EnvironmentOutlined,
  SettingOutlined,
  MoneyCollectOutlined
  ,CloudUploadOutlined
} from '@ant-design/icons';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import NotificationBell from '../notifications/NotificationBell';

const { Header, Sider, Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { token: { colorBgContainer } } = theme.useToken();
  const user = useSelector((state: RootState) => state.auth.user);

  const isAdmin = user?.role === 'administrator';

  const menuItems = isAdmin ? [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: 'Pregled',
      onClick: () => navigate('/admin/dashboard'),
    },
    {
      key: '/admin/imports',
      icon: <CloudUploadOutlined />,
      label: 'Uvoz podataka',
      onClick: () => navigate('/admin/imports'),
    },
    {
      key: 'water-meters',
      icon: <TableOutlined />,
      label: 'Vodomjeri',
      onClick: () => navigate('/admin/water-meters'),
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'Korisnici',
      onClick: () => navigate('/admin/users'),
    },
    {
      key:'bills',
      icon: <MoneyCollectOutlined />,
      label: 'Računi',
      onClick: () => navigate('/admin/bills'),
    
    },
    {
      key: '/admin/issues',
      icon: <ToolOutlined />,
      label: 'Prijave kvarova',
      onClick: () => navigate('/admin/issues'),
    },
    {
      key: '/admin/notifications',
      icon: <NotificationOutlined />,
      label: 'Obavještenja',
      onClick: () => navigate('/admin/notifications'),
    },
    {
      key: '/admin/areas',
      icon: <EnvironmentOutlined />,
      label: 'Područja i ulice',
      onClick: () => navigate('/admin/areas'),
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: 'Podešavanja',
      onClick: () => navigate('/admin/settings'),
    }
  ] : [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/dashboard'),
    },
    {
      key: 'readings',
      icon: <TableOutlined />,
      label: 'Očitavanja',
      onClick: () => navigate('/readings'),
    },
    {
      key:'bills',
      icon: <MoneyCollectOutlined />,
      label: 'Računi',
      onClick: () => navigate('/bills'),
    
    },
    {
      key: '/issues',
      icon: <ToolOutlined />,
      label: 'Moje prijave',
      onClick: () => navigate('/issues'),
    },
    //add reading
    {
      key: '/notifications/settings',
      icon: <SettingOutlined />,
      label: 'Podešavanja obavještenja',
      onClick: () => navigate('/notifications/settings'),
    },
    {
      key: '/notifications',
      icon: <NotificationOutlined />,
      label: 'Obavještenja',
      onClick: () => navigate('/notifications'),
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const userMenu = (
    <Menu items={[
      {
        key: '1',
        icon: <UserOutlined />,
        label: 'Profil',
        onClick: () => navigate('/profile'),
      },
      {
        key: '2',
        icon: <SettingOutlined />,
        label: 'Podešavanja obavještenja',
        onClick: () => navigate('/notification-settings'),
      },
      {
        key: '3',
        icon: <LogoutOutlined />,
        label: 'Odjava',
        onClick: handleLogout,
      },
    ]} />
  );

  return (
    <Layout className="app-shell" style={{ minHeight: '100vh' }}>
      <Sider width={264} trigger={null} collapsible collapsed={collapsed} className="app-sider">
        <div className={`brand-lockup${collapsed ? ' brand-lockup-collapsed' : ''}`}>
          <img
            src="/moj-vodomjer-transparent.png"
            alt="Moj Vodomjer Doboj"
            className="brand-logo"
          />
          {!collapsed && <div className="brand-copy">
            <strong>Moj Vodomjer</strong>
            <strong>Doboj</strong>
            <span>Gradski vodovod Doboj</span>
          </div>}
        </div>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[location.pathname]}
          className="app-menu"
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header className="app-header">
          <div className="header-inner">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
            <div className="flex items-center space-x-4">
              <NotificationBell />
              <Dropdown overlay={userMenu} trigger={['click']}>
                <div className="cursor-pointer flex items-center space-x-2">
                  <Avatar icon={<UserOutlined />} />
                  <span className="header-user-name">{user?.name}</span>
                </div>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content
          className="app-content"
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
